export default "../../src/img/cats.jpg";